import Amplify, { Auth, Hub } from 'aws-amplify';
import {
  redirectAfterSessionLoss,
  startLogoutMarkerMonitor,
} from './auth-session-expiry';

const {
  NX_COGNITO_USER_POOL_ID: userPoolId,
  NX_COGNITO_REGION: region,
  NX_COGNITO_USER_POOL_WEB_CLIENT_ID: userPoolWebClientId,
  NX_ENABLE_COGNITO_COOKIE_STORAGE: enableCognitoCookieStorage,
  NX_COOKIE_DOMAIN: cookieDomain,
} = process.env;

const canUseCookieDomain =
  typeof window !== 'undefined' &&
  Boolean(cookieDomain) &&
  window.location.hostname.endsWith(cookieDomain!.replace(/^\./, ''));

const shouldUseCognitoCookieStorage =
  enableCognitoCookieStorage === 'true' && canUseCookieDomain;

export const awsConfig = {
  Auth: {
    userPoolId,
    region,
    userPoolWebClientId,
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    ...(shouldUseCognitoCookieStorage
      ? {
          cookieStorage: {
            domain: cookieDomain,
            secure: true,
            path: '/',
            sameSite: 'lax',
            expires: 30,
          },
        }
      : {}),
  },
};

Amplify.configure(awsConfig);
Auth.configure(awsConfig);

Hub.listen('auth', ({ payload: { event } }) => {
  if (event !== 'signOut' && event !== 'tokenRefresh_failure') return;

  redirectAfterSessionLoss();
});

startLogoutMarkerMonitor();
